import { CategoryResponseDTO } from 'infrastructure/dtos/category/responses/CategoryResponseDTO';
import { ApiPathConfig } from '../types';
import { CategoryRequestDTO } from 'infrastructure/dtos/category/requests/CategoryRequestDTO';

export const List: ApiPathConfig<void, { data: CategoryResponseDTO[] }> = {
  method: 'GET',
  path: '/admin/categories',
  response: { data: [] } as { data: CategoryResponseDTO[] },
};

export const Create: ApiPathConfig<
  CategoryRequestDTO,
  {
    data: CategoryResponseDTO;
  }
> = {
  method: 'POST',
  path: '/admin/categories/create',
  response: { data: {} as CategoryResponseDTO },
};
